import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { DeductionsList } from "../../components/DeductionsList";


export interface IDeductionsListPage {}

export const DeductionsListPage: FC<IDeductionsListPage> = (
  props: IDeductionsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Deductions List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Deductions", navigateTo: "/company/deductions/list" },
      ]}
      mainContents={<DeductionsList />}
    />
  );
};
